import Icon from '@mdi/react';
import type { OverrideProps } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';
import { styled } from '@mui/material/styles';

import iconTheme from '../../theme/legacy/components/svgIcon';
import colors from '../../theme/legacy/colors';
import { forwardRef } from 'react';
import { ThemeAvailableColors } from '../../types';

const fontSizeStyles = {
    inherit: iconTheme.styleOverrides.fontSizeInherit,
    xsmall: iconTheme.styleOverrides.fontSizeXsmall,
    small: iconTheme.styleOverrides.fontSizeSmall,
    medium: iconTheme.styleOverrides.fontSizeMedium,
    large: iconTheme.styleOverrides.fontSizeLarge,
    xlarge: iconTheme.styleOverrides.fontSizeXLarge,
};

const StyledIcon = styled(Icon, {
    shouldForwardProp: (propName) => propName !== 'color',
})<Props>(({ theme, color, fontSize }) => {
    return {
        color:
            color &&
            (color === 'inherit'
                ? 'inherit'
                : color === 'action'
                ? colors.action.main
                : theme.palette[color].main),
        // @ts-ignore
        ...fontSizeStyles[fontSize],
        fill: 'currentColor',
        width: '1em',
        height: '1em',
        flexShrink: 0,
        transition: theme.transitions.create('fill', {
            duration: theme.transitions.duration.shorter,
        }),
        display: 'inline-block',
        userSelect: 'none',
    };
});

StyledIcon.defaultProps = {
    color: undefined,
};

type MuiIconProps = OverrideProps<SvgIconTypeMap, 'svg'>;
type MdiIconSpecificProps = {
    color?: ThemeAvailableColors;
    rotate?: number;
};

export type Props = {
    path: string;
} & MdiIconSpecificProps &
    Omit<MuiIconProps, keyof MdiIconSpecificProps>;

const MdiIcon = forwardRef((props: Props, ref: any) => {
    const { path, ...rest } = props;

    return <StyledIcon ref={ref} path={path} {...rest} />;
});

export default MdiIcon;
